export default __webpack_public_path__ + "static/media/Andre-Siegert.d84dcbf5.jpg";